import { render, staticRenderFns } from "./PromoCodeNewForm.vue?vue&type=template&id=655b6ecf&scoped=true&"
import script from "./PromoCodeNewForm.vue?vue&type=script&lang=js&"
export * from "./PromoCodeNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b6ecf",
  null
  
)

export default component.exports